import { render } from "./index-loader.vue?vue&type=template&id=4f866aff"
import script from "./index-loader.vue?vue&type=script&lang=js"
export * from "./index-loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__